export type ReportingTimeBasis = 'start' | 'completion';
export type DurationSource = 'sbc' | 'teams';

export function formatCallDuration(seconds: number | null): string {
  if (seconds === null) return '—';
  const roundedSeconds = Math.round(seconds);
  const minutes = Math.floor(roundedSeconds / 60);
  const remainingSeconds = roundedSeconds % 60;
  return `${minutes}m ${remainingSeconds}s`;
}

export function reportingTimeLabel(basis: ReportingTimeBasis | null): string {
  if (basis === 'completion') return 'Completed';
  if (basis === 'start') return 'Started';
  return 'Time';
}

export function durationSourceLabel(source: DurationSource | null): string | null {
  if (source === 'teams') return 'Teams duration';
  if (source === 'sbc') return 'Call record duration';
  return null;
}

export function durationCoverageLabel(
  knownCount: number,
  totalCount: number,
  partial: boolean,
): string | null {
  if (totalCount === 0) return null;
  if (knownCount === 0) return `No durations available (${totalCount.toLocaleString()} records)`;
  if (partial) return `${knownCount.toLocaleString()} of ${totalCount.toLocaleString()} durations available`;
  return null;
}
